// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonState } from "@1js/acui-button/lib/Next";
import {} from "@fluentui/react-components";
import { customTokens } from "@1js/acui-theme";
import {
  makeStyles,
  mergeClasses,
  shorthands,
  useMenuButtonStyles_unstable,
} from "@fluentui/react-components";
// eslint-disable-next-line no-restricted-imports
import { useCommonDisabledStyles } from "@1js/acui-common/lib/styling/next";
import { controlStylingConstants } from "@1js/acui-common";
// eslint-disable-next-line no-restricted-imports
import { HighContrastSelector } from "@1js/acui-common/lib/styling/next/commonStyles.styles";

const useMenuButtonStyles = makeStyles({
  base: {
    width: "100%",
    minWidth: "16px",
    padding: "0px",
    /* This helps change color of menu button depending up on the theme(dark or light) */
    fill: customTokens.colorNeutralForeground1,
    backgroundColor: customTokens.colorNeutralBackground1,
    borderRadius: customTokens.borderRadiusMedium,
    // The left of this component is where the button display is located, setting the border left
    // to none so just the menu button can display the border
    borderTopLeftRadius: customTokens.borderRadiusNone,
    borderBottomLeftRadius: customTokens.borderRadiusNone,
    borderTop: "none",
    borderBottom: "none",
    borderRight: "none",
    [`${HighContrastSelector}`]: {
      ...shorthands.border(
        customTokens.strokeWidthThin,
        "solid",
        customTokens.colorNeutralForeground1Hover
      ),
    },
  },
  baseWithMinTargetSize: {
    minWidth: `${controlStylingConstants.minTargetSize}px`,
  },
  /* Fixed height as per the size to keep it inline with the design  */
  medium: {
    height: "30px",
  },
  large: {
    height: "60px",
  },
});

const useMenuButtonIconStyles = makeStyles({
  base: {
    margin: "0px",
  },
  medium: {
    width: customTokens.spacingHorizontalM,
    height: customTokens.spacingVerticalM,
  },
  large: {
    width: customTokens.spacingHorizontalS,
    height: customTokens.spacingVerticalS,
  },
});

export const usePreviewGalleryMenuButtonStyles = (
  state: AppMenuButtonState
): AppMenuButtonState => {
  const menuButtonStyles = useMenuButtonStyles();
  const menuButtonIconStyles = useMenuButtonIconStyles();
  const disabledStyles = useCommonDisabledStyles();

  state.root.className = mergeClasses(
    menuButtonStyles.base,
    state.size?.toLowerCase() === "large"
      ? menuButtonStyles.large
      : menuButtonStyles.medium,
    menuButtonStyles.baseWithMinTargetSize,
    "ms-ButtonNext",
    "ms-Button",
    state.root.className
  );

  if (state.menuIcon) {
    state.menuIcon.className = mergeClasses(
      "ms-Button-icon",
      menuButtonIconStyles.base,
      state.size?.toLowerCase() === "large"
        ? menuButtonIconStyles.large
        : menuButtonIconStyles.medium,
      (state?.disabled || state?.disabledFocusable) && disabledStyles.base,
      state.menuIcon.className
    );
  }

  useMenuButtonStyles_unstable(state);

  return state;
};
